var map = {
	"./Loading-Icon.gif": 74177,
	"./app-awareness-phone.png": 65336,
	"./app-modal-android@2x.png": 61369,
	"./app-modal-iphone@2x.png": 90141,
	"./app-promo-banner-background.png": 18170,
	"./box-prices/2-portions.png": 13405,
	"./box-prices/2-portions.webp": 61709,
	"./box-prices/4-portions.png": 73777,
	"./box-prices/4-portions.webp": 6289,
	"./box-prices/box-prices-hero.jpg": 50080,
	"./box-prices/couples-box.jpg": 4535,
	"./box-prices/family-box.jpg": 16474,
	"./box-prices/four-person-box.jpg": 59810,
	"./box-prices/two-person-box.jpg": 95847,
	"./discount-modal-header.jpg": 30046,
	"./discount-softening-experiment-modal-image.jpg": 47022,
	"./earn-reward-background.jpg": 75703,
	"./five-recipes/five-recipes.png": 70498,
	"./food/cauli-mac-cheese.jpg": 12679,
	"./food/jamaican-squash-coconut-stew.jpg": 73419,
	"./food/sweet-potato-dal.jpg": 50890,
	"./food/sweet-potato-sag-aloo.jpg": 52431,
	"./gousto-box.jpg": 73926,
	"./gousto-boxes.jpg": 68943,
	"./gousto-welcome-journey-rollover.jpg": 31182,
	"./hungry-for-savings.png": 26051,
	"./icon-gbox.svg": 78122,
	"./icon-van.svg": 49814,
	"./menu/FebYouary_desktop.jpg": 80840,
	"./menu/FebYouary_mobile.jpg": 73374,
	"./menu/FebYouary_tablet.jpg": 72326,
	"./menu/default_desktop_no_click.png": 98206,
	"./menu/default_mobile_no_click.png": 68880,
	"./menu/default_tablet_no_click.png": 85618,
	"./menu/spottyTileBorder.png": 49481,
	"./my-gousto-pricing-modal.svg": 27462,
	"./pause-osr-modal-bg.jpg": 22168,
	"./product-placeholder.png": 50767,
	"./recipe-placeholder.png": 48678,
	"./red-rice-pattern.png": 77,
	"./zest-logo.svg": 31674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29171;